import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    CircularProgress,
    FormControl,
    Grid,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { isDateExpired } from "../Utils/UtilityMethods";
import { red } from "@mui/material/colors";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface Props {
    expanded: boolean;
    accordianIndexValue: number;
    accordionClicked(arg0: number): void;
    error: any;
    data: any;
    loading: boolean;
}

export default function NightCurrencySection(props: Props): JSX.Element {
    const theme = useTheme();
    const isMedium = useMediaQuery(theme.breakpoints.up("sm"));

    let horizontalPadding = 4;

    if (isMedium) horizontalPadding = 6;

    if (props.error) return <>Error fetching Night Currency</>;

    return (
        <>
            <FormControl fullWidth sx={{ px: horizontalPadding }}>
                <Accordion sx={{ background: "#F7F8F9" }} expanded={props.expanded} onChange={() => props.accordionClicked(props.accordianIndexValue)}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Grid container justifyContent={"space-between"} alignItems={"center"}>
                            <Typography variant="button" fontSize={18} marginLeft={2}>
                                NIGHT CURRENCY
                            </Typography>
                            {props.loading ? <CircularProgress size={25} sx={{ mr: 2 }} /> : null}
                        </Grid>
                    </AccordionSummary>
                    {/* Checking for loading here because, if the accordion is open then the data will be visible to user during loading and then update in front of the user when the fetch is complete.
                    This data update infront of user is not ideal.
                    Once the loading is complete the user must see the final data. */}
                    {!props.loading && props.data && props.data.getNightCurrencyByPersonAndDate ? (
                        <AccordionDetails>
                            <Box marginLeft={2} marginBottom={1} marginTop={2}>
                                <Grid container alignItems="baseline" sx={{ background: red }}>
                                    <TextField
                                        size="small"
                                        sx={{ width: 110 }}
                                        inputProps={{
                                            style: {
                                                textAlign: "end",
                                                borderRadius: 4,
                                                background: "white",
                                            },
                                        }}
                                        value={
                                            (props.data.getNightCurrencyByPersonAndDate.totals &&
                                                props.data.getNightCurrencyByPersonAndDate.totals[0]?.night_takeoff) ??
                                            ""
                                        }
                                    />
                                    <Typography fontSize={16} sx={{ marginLeft: 1, display: "inline" }}>
                                        Night Takeoff Last 90
                                    </Typography>
                                </Grid>
                            </Box>
                            <Box marginLeft={2} marginBottom={1} marginTop={2}>
                                <Grid container alignItems="baseline">
                                    <TextField
                                        size="small"
                                        sx={{ width: 110 }}
                                        inputProps={{
                                            style: {
                                                textAlign: "end",
                                                borderRadius: 4,
                                                background: "white",
                                            },
                                        }}
                                        value={
                                            (props.data.getNightCurrencyByPersonAndDate.totals &&
                                                props.data.getNightCurrencyByPersonAndDate.totals[0]?.night_landing) ??
                                            ""
                                        }
                                    />
                                    <Typography fontSize={16} sx={{ marginLeft: 1, display: "inline" }}>
                                        Night Landing Last 90
                                    </Typography>
                                </Grid>
                            </Box>
                            <Box marginLeft={2} marginBottom={1} marginTop={2}>
                                <Grid container alignItems="baseline">
                                    <TextField
                                        size="small"
                                        sx={{ width: 110 }}
                                        inputProps={{
                                            style: {
                                                textAlign: "end",
                                                borderRadius: 4,
                                                background: "white",
                                            },
                                        }}
                                        value={
                                            (props.data.getNightCurrencyByPersonAndDate.expirations &&
                                                props.data.getNightCurrencyByPersonAndDate.expirations[0]?.expiry) ??
                                            ""
                                        }
                                    />
                                    {props.data.getNightCurrencyByPersonAndDate.expirations &&
                                    isDateExpired(props.data.getNightCurrencyByPersonAndDate.expirations[0]?.expiry) ? (
                                        <Typography fontSize={16} sx={{ marginLeft: 1, display: "inline" }} color={"error"}>
                                            Expired
                                        </Typography>
                                    ) : (
                                        <Typography fontSize={16} sx={{ marginLeft: 1, display: "inline" }}>
                                            Expiry
                                        </Typography>
                                    )}
                                </Grid>
                            </Box>

                            <Box marginLeft={2} marginBottom={1} marginTop={2}>
                                <Grid container alignItems="baseline">
                                    <TextField
                                        size="small"
                                        sx={{ width: 110 }}
                                        inputProps={{
                                            style: {
                                                textAlign: "end",
                                                borderRadius: 4,
                                                background: "white",
                                            },
                                        }}
                                        value={
                                            (props.data.getNightCurrencyByPersonAndDate.totals &&
                                                props.data.getNightCurrencyByPersonAndDate.totals[1]?.night_takeoff) ??
                                            ""
                                        }
                                    />
                                    <Typography fontSize={16} sx={{ marginLeft: 1, display: "inline" }}>
                                        Night Takeoff Last 180
                                    </Typography>
                                </Grid>
                            </Box>
                            <Box marginLeft={2} marginBottom={1} marginTop={2}>
                                <Grid container alignItems="baseline">
                                    <TextField
                                        size="small"
                                        sx={{ width: 110 }}
                                        inputProps={{
                                            style: {
                                                textAlign: "end",
                                                borderRadius: 4,
                                                background: "white",
                                            },
                                        }}
                                        value={
                                            (props.data.getNightCurrencyByPersonAndDate.totals &&
                                                props.data.getNightCurrencyByPersonAndDate.totals[1]?.night_landing) ??
                                            ""
                                        }
                                    />
                                    <Typography fontSize={16} sx={{ marginLeft: 1, display: "inline" }}>
                                        Night Landing Last 180
                                    </Typography>
                                </Grid>
                            </Box>
                            <Box marginLeft={2} marginBottom={1} marginTop={2}>
                                <Grid container alignItems="baseline">
                                    <TextField
                                        size="small"
                                        sx={{ width: 110 }}
                                        inputProps={{
                                            style: {
                                                textAlign: "end",
                                                borderRadius: 4,
                                                background: "white",
                                            },
                                        }}
                                        value={
                                            (props.data.getNightCurrencyByPersonAndDate.expirations &&
                                                props.data.getNightCurrencyByPersonAndDate.expirations[1]?.expiry) ??
                                            ""
                                        }
                                    />
                                    {props.data.getNightCurrencyByPersonAndDate.expirations &&
                                    isDateExpired(props.data.getNightCurrencyByPersonAndDate.expirations[1]?.expiry) ? (
                                        <Typography fontSize={16} sx={{ marginLeft: 1, display: "inline" }} color={"error"}>
                                            Expired
                                        </Typography>
                                    ) : (
                                        <Typography fontSize={16} sx={{ marginLeft: 1, display: "inline" }}>
                                            Expiry
                                        </Typography>
                                    )}
                                </Grid>
                            </Box>
                        </AccordionDetails>
                    ) : null}
                </Accordion>
            </FormControl>
        </>
    );
}
